import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Avvio rapido',
  description: 'Segui questa guida per arrivare al lancio il prima possibile',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Preferenze notifiche',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Orari e posizione',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identità del ristorante',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Impostazioni ordini',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Configurazione menu',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing e fedeltà',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Il mio negozio',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Vai live',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Completo',
  },
  toasts: {
    failed_to_load_onboarding: 'Caricamento passaggi di onboarding non riuscito',
  },
};
